import { buildDraft, setLevel, toggleNode } from '../utils/permissionTree';
import { ROLE_BUILDER_STEP, studiosOfRole } from '../utils/roleBuilderRules';

/** Start from "Blank" (no template). */
export const START_FROM_BLANK = 'blank';

/** Fresh wizard state over the studios' permission nodes. */
export const createRoleBuilderState = (nodes) => ({
  currentStep: ROLE_BUILDER_STEP.DETAILS,
  name: '',
  description: '',
  startFrom: START_FROM_BLANK,
  studioIds: [],
  permissionDraft: buildDraft(nodes, []),
  memberIds: [],
  conflictName: null,
});

/**
 * Reducer of the New role wizard. Actions that touch permissions carry the `nodes` of the
 * catalog (`{ type, nodes, ... }`) so the reducer stays pure.
 */
export const roleBuilderReducer = (state, action) => {
  switch (action.type) {
    case 'setName':
      return { ...state, name: action.name };
    case 'setDescription':
      return { ...state, description: action.description };
    case 'startFrom': {
      if (!action.role) {
        return { ...state, startFrom: START_FROM_BLANK, studioIds: [], permissionDraft: buildDraft(action.nodes, []) };
      }
      return {
        ...state,
        startFrom: action.role.id,
        studioIds: studiosOfRole(action.role),
        permissionDraft: buildDraft(action.nodes, []),
      };
    }
    case 'toggleStudio':
      return {
        ...state,
        studioIds: state.studioIds.includes(action.studioId)
          ? state.studioIds.filter((id) => id !== action.studioId)
          : [...state.studioIds, action.studioId],
      };
    case 'togglePermission':
      return { ...state, permissionDraft: toggleNode(action.nodes, state.permissionDraft, action.id, action.on) };
    case 'setPermissionLevel':
      return { ...state, permissionDraft: setLevel(action.nodes, state.permissionDraft, action.id, action.level) };
    case 'toggleMember':
      return {
        ...state,
        memberIds: state.memberIds.includes(action.memberId)
          ? state.memberIds.filter((id) => id !== action.memberId)
          : [...state.memberIds, action.memberId],
      };
    case 'goTo':
      return { ...state, currentStep: action.step };
    case 'nameConflict':
      return { ...state, conflictName: action.name, currentStep: ROLE_BUILDER_STEP.DETAILS };
    default:
      return state;
  }
};
